import React from 'react';
import { InboundOrOutboundOrdersList } from 'components/inbound-outbound-orders';

export function InboundOrders() {
  return <InboundOrOutboundOrdersList pageTitle="Inbound Orders" />;
}
